import { defineMessages } from 'react-intl';

export const messages: {
	appStackLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	appStackLabel: {
		id: 'search-page.controllers.all-apps-icon.appStackLabel',
		defaultMessage: 'Apps not shown',
		description: 'Accessible label required by the decorative stack of additional app icons',
	},
});
